<template>
  <div>
    <div class="md:flex">
      <div class="md:w-2/5 text-center">
        <h3
          class="text-custom text-2xl lg:text-3xl mb-5 md:mb-0 leading-none font-bold"
        >
          Active Subscriptions
        </h3>
        <h5 class="md:text-xl my-4 text-white">
          {{
            subscriptionData && subscriptionData.planInterval
              ? subscriptionData.planInterval
              : ""
          }}
        </h5>
        <div class="buttons mt-3">
          <button
            v-if="
              subscriptionData &&
                subscriptionData.planInterval == 'Monthly' &&
                subscriptionData.status != 'canceled' &&
                !subscriptionData.cancelAtPeriodEnd
            "
            class="border-custom subscription-btns"
            @click="upgradeSubscription"
          >
            Upgrade Subscription
          </button>

          <button
            v-if="
              subscriptionData &&
                subscriptionData.status != 'canceled' &&
                subscriptionData.cancelAtPeriodEnd
            "
            class="border-red-700 subscription-btns"
            @click="revokeCancellation"
          >
            Revoke Cancellation of Subscription
          </button>
          <button
            class="border-custom  subscription-btns"
            @click="viewCustomerPortal"
          >
            Manage Cards & Billing
          </button>
          <button
            v-if="
              subscriptionData &&
                subscriptionData.status == 'active' &&
                !subscriptionData.cancelAtPeriodEnd
            "
            class="border-red-700 subscription-btns"
            @click="Unsubscribe"
          >
            Unsubscribe
          </button>
        </div>
      </div>
      <div class="md:w-3/5">
        <ol class="listify mt-8 list-none list-inside text-white">
          <li>
            - Paid Subscriber receives at least
            {{
              subscriptionData && subscriptionData.planInterval == "Yearly"
                ? "24"
                : "1-2"
            }}
            SPYOWS signals
          </li>
          <li>
            - Each SPYOWS signal is delivered by either Email or via SMS alert
            based
          </li>
          <li>
            - Subscriber will receive alerts for trades for consideration
          </li>
          <li>
            - Buy or Signal may have Limited time to execute.
          </li>
          <li>- Automatic Renewal Monthly unless cancelled.</li>
        </ol>
        <ol
          v-if="subscriptionData && subscriptionData.cancelAtPeriodEnd == true"
          class="listify mt-8 list-none list-inside text-white"
        >
          <li>
            - You have Unsubscribed to the Membership on
            {{
              moment(subscriptionData.canceledAt * 1000).format("DD-MM-YYYY")
            }}, but the subcription will be active till
            {{ moment(subscriptionData.cancelAt * 1000).format("DD-MM-YYYY") }}
          </li>
          <li>
            - After the Above period, you no longer billed & also will not
            receive any signals.
          </li>
        </ol>
      </div>
    </div>

    <div class="w-full mt-3 text-left md:text-right">
      <div
        class="w-full md:flex justify-end items-center font-medium p-2 md:mb-2"
      >
        <span class="text-white text-lg mr-3">Referral Link:</span
        ><input
          type="text"
          disabled="true"
          class="focus:outline-none w-full md:w-3/4 text-gray-900 bg-white py-2 md:py-3 bg-opacity-75 border rounded-full px-5"
          placeholder="referall"
          v-model="referral"
        />
        <button
          v-clipboard:copy="referral"
          v-clipboard:success="onCopy"
          v-clipboard:error="onError"
        >
          <i class="bx bx-clipboard mr-1"></i>
          Copy
        </button>
      </div>
      <div class="w-full md:w-3/4 mx-auto mb-3 text-left md:text-center">
        <span
          class="cursor-pointer text-sm md:text-lg font-medium text-gray-200 leading-none"
        >
          Refer a User and
          <span class="text-custom">
            Get 1 months Subscription Free
          </span>
          when user purchases the subscription.
        </span>
      </div>
      <div class="md:w-2/5 mx-auto text-center font-medium p-2 md:mb-5">
        <router-link
          to="/user/signals-history"
          class="block text-custom my-2 py-2 px-2 w-auto mx-auto rounded-full border-2 bg-transparent hover:bg-custom hover:text-white hover:border-custom appearance-none focus:outline-none"
        >
          View Signal History
        </router-link>
      </div>
    </div>
  </div>
</template>
<!-- Facebook Pixel Code -->
<script>
!(function(f, b, e, v, n, t, s) {
  if (f.fbq) return;
  n = f.fbq = function() {
    n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
  };
  if (!f._fbq) f._fbq = n;
  n.push = n;
  n.loaded = !0;
  n.version = "2.0";
  n.queue = [];
  t = b.createElement(e);
  t.async = !0;
  t.src = v;
  s = b.getElementsByTagName(e)[0];
  s.parentNode.insertBefore(t, s);
})(
  window,
  document,
  "script",
  "https://connect.facebook.net/en_US/fbevents.js"
);
// eslint-disable-next-line no-undef
fbq("init", "261976718326827");
// eslint-disable-next-line no-undef
fbq("track", "PageView");
</script>
<noscript><img height="1" width="1" style="display:none"
src="https://www.facebook.com/tr?id=261976718326827&ev=PageView&noscript=1"
/></noscript>
<!-- End Facebook Pixel Code -->
<script>
// @ is an alias to /src
// import Layout from "@/views/user/Layout.vue";
import moment from "moment";
import firebase from "firebase";
import signUp from "@/views/auth/Signup.vue";
export default {
  name: "Subscriptions",
  metaInfo: {
    title: "Spyows",
    titleTemplate: "%s | Subscriptions",
    htmlAttrs: {
      lang: "en",
      amp: true
    }
  },
  data() {
    return {
      moment: moment,
      subscriptionData: {},
      userData: {},
      referral: ""
    };
  },
  mounted() {
    let user = firebase.auth().currentUser;
    firebase
      .database()
      .ref(`users/${user.uid}`)
      .on("value", snapshot => {
        this.userData = snapshot.val();
        this.referral =
          "http://spyonwallstreet.com/referral/" +
          (this.userData.referralId || "");
      });
    firebase
      .database()
      .ref(`subscriptions/${user.uid}`)
      .on("value", snapshot => {
        this.subscriptionData = snapshot.val();
      });
  },
  methods: {
    viewCustomerPortal() {
      firebase
        .functions()
        .httpsCallable("createPortalLink")({
          returnUrl: window.location.href
        })
        .then(res => {
          window.open(res.data.url, "blank");
          console.log("response from create portal", res);
        })
        .catch(() => {
          console.log("err occured while creatiing portal link");
        });
    },
    Unsubscribe() {
      firebase
        .functions()
        .httpsCallable("manageSubscriptionCancellation")({
          subscriptionId: this.subscriptionData.subscriptionId,
          action: "cancel"
        })
        .then(res => {
          console.log("response from cancelSubscriptionAtPeriodEnd", res);
        })
        .catch(() => {
          console.log("err occured while cancelling subscription");
        });
    },
    revokeCancellation() {
      firebase
        .functions()
        .httpsCallable("manageSubscriptionCancellation")({
          subscriptionId: this.subscriptionData.subscriptionId,
          action: "revoke"
        })
        .then(res => {
          console.log("response from cancelSubscriptionAtPeriodEnd", res);
        })
        .catch(() => {
          console.log("err occured while cancelling subscription");
        });
    },
    upgradeSubscription() {
      firebase
        .functions()
        .httpsCallable("upgradeSubscription")({
          subscriptionId: this.subscriptionData.subscriptionId,
          newPriceId: "price_1HFt1sH9q88vhZpEJFKGMDw7"
        })
        .then(res => {
          console.log("response from upgradeSubscription", res);
        })
        .catch(() => {
          console.log("err occured while upgradeSubscription subscription");
        });
    },
    onCopy: function(e) {
      this.$vToastify.info("Copied to clipboard");
    },
    onError: function(e) {
      this.$vToastify.error("Failed to copy");
    }
  }
};
</script>

<style lang="postcss" scoped>
.buttons {
}

@screen md {
  .buttons {
    @apply px-5;
  }

  .listify li {
    @apply my-2;
  }
}

@screen lg {
  .buttons {
    @apply px-20;
  }
}

.buttons a,
button {
  @apply block text-white my-2 py-2 px-2 w-auto mx-auto rounded-full border-2 bg-transparent;
}
.subscription-btns {
  width: -webkit-fill-available;
}
</style>
